var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ViewChild, HostBinding, Input, Output, EventEmitter, } from '@angular/core';
import { CookieLawService, } from './cookie-law.service';
import { CookieLawElementComponent } from './cookie-law-element.component';
var CookieLawComponent = (function () {
    function CookieLawComponent(_service) {
        this._service = _service;
        this.seen = true;
        this.isSeen = new EventEmitter();
        this.name = 'cookieLawSeen';
    }
    Object.defineProperty(CookieLawComponent.prototype, "cookieLawSeen", {
        get: function () {
            return this._service.seen(this.name);
        },
        enumerable: true,
        configurable: true
    });
    CookieLawComponent.prototype.ngOnInit = function () {
        this.seen = this._service.seen(this.name);
    };
    CookieLawComponent.prototype.hasBeenDismissed = function () {
        this._service.storeCookie(this.name, this.expiration);
        this.seen = true;
        this.isSeen.emit(true);
    };
    CookieLawComponent.prototype.dismiss = function () {
        this.cookieLawComponent.dismiss();
    };
    return CookieLawComponent;
}());
__decorate([
    HostBinding('attr.seen'),
    __metadata("design:type", Boolean)
], CookieLawComponent.prototype, "seen", void 0);
__decorate([
    ViewChild(CookieLawElementComponent),
    __metadata("design:type", CookieLawElementComponent)
], CookieLawComponent.prototype, "cookieLawComponent", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], CookieLawComponent.prototype, "name", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], CookieLawComponent.prototype, "learnMore", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], CookieLawComponent.prototype, "target", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], CookieLawComponent.prototype, "position", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], CookieLawComponent.prototype, "expiration", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], CookieLawComponent.prototype, "awsomeCloseIcon", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], CookieLawComponent.prototype, "isSeen", void 0);
CookieLawComponent = __decorate([
    Component({
        selector: 'cookie-law',
        template: "\n    <cookie-law-el *ngIf=\"!seen\"\n                   [awsomeCloseIcon]=\"awsomeCloseIcon\"\n                   [learnMore]=\"learnMore\"\n                   [target]=\"target\"\n                   [position]=\"position\"\n                   (isSeen)=\"hasBeenDismissed()\"><ng-content></ng-content></cookie-law-el>\n  ",
    }),
    __metadata("design:paramtypes", [CookieLawService])
], CookieLawComponent);
export { CookieLawComponent };
//# sourceMappingURL=cookie-law.component.js.map